import { Button, Stack, TextField } from "@mui/material";
import ActionButton from "components/react-lib/generic-ui/ActionButton";
import AlertMessage from "components/react-lib/generic-ui/AlertMessage";
import { httpsCallable } from "firebase/functions";
import { functions } from "firebaseApp";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { popupActions } from "store/react-lib/generic-ui/popup";

export default function YoutubeTranscript({ value, setValue }) {
  const dispatch = useDispatch();

  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [videoUrl, setVideoUrl] = useState("");

  const handleProcess = async () => {
    try {
      setProcessing(true);
      setError("");
      const res = await httpsCallable(
        functions,
        "downloadYoutubeTranscript"
      )({
        videoUrl,
      });
      const {success, ...transcript} = res.data;
      if (!success) {
        setError(transcript.error);
      } else {
        setValue({...transcript, name: videoUrl});
      }
    } catch (error) {
      console.log(error);
      dispatch(popupActions.showError("An error occurred."));
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Stack spacing={1}>
      {error && <AlertMessage severity="error">{error}</AlertMessage>}
      <TextField
        label="Video URL"
        value={videoUrl}
        onChange={(event) => setVideoUrl(event.target.value)}
      />
      <ActionButton
        disabled={!Boolean(videoUrl)}
        variant="contained"
        processing={processing}
        onClick={handleProcess}
      >
        Process
      </ActionButton>
      {value && (
        <AlertMessage severity="success">Transcript loaded successfully.</AlertMessage>
      )}
    </Stack>
  );
}
